import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var IdasService = /** @class */ (function () {
    function IdasService(httpClient) {
        this.httpClient = httpClient;
        this.getOnsetExamDataCompleted = new EventEmitter();
        this.postOnsetExamResultCompleted = new EventEmitter();
    }
    IdasService.prototype.getOnsetExamData = function (token) {
        var _this = this;
        this.httpClient
            .get(environment.apiUrl + 'idas' + '/' + 'onset' + '/' + token)
            .subscribe(function (res) { _this.getOnsetExamDataCompleted.emit(res); }, function (err) {
            console.log(err.error);
            console.log(err.name);
            console.log(err.message);
            console.log(err.status);
            _this.getOnsetExamDataCompleted.emit(null);
        });
    };
    IdasService.prototype.postOnsetExamResult = function (token, onsetExamResultDto) {
        var _this = this;
        // TODO send result to backend
        this.httpClient
            .post(environment.apiUrl + 'idas' + '/' + 'onset' + '/' + token + '/' + 'results', onsetExamResultDto)
            .subscribe(function (res) { _this.postOnsetExamResultCompleted.emit(res); }, function (err) {
            console.log(err.error);
            console.log(err.name);
            console.log(err.message);
            console.log(err.status);
        });
    };
    IdasService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            console.error(error);
            console.log(operation + " failed: " + error.message);
            return of(result);
        };
    };
    IdasService.ngInjectableDef = i0.defineInjectable({ factory: function IdasService_Factory() { return new IdasService(i0.inject(i1.HttpClient)); }, token: IdasService, providedIn: "root" });
    return IdasService;
}());
export { IdasService };
